/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TeamImportResponse = {
    type: 'array',
    contains: {
        type: 'any-of',
        contains: [{
            type: 'TeamImport',
        }, {
            type: 'string',
        }],
    },
} as const;
